const env = process.env;

export class AppConstants {
  static token: string = "";

  /** Production defaults — used when REACT_APP_* vars are not set (e.g. CI/build). */
  static base_url_api: string =
    env.REACT_APP_API_URL ?? "https://crm.karamad.net/api/v1/";
  static base_url_download: string =
    env.REACT_APP_BASE_URL ?? "https://crm.karamad.net";
  static base_url_img: string = `${
    env.REACT_APP_BASE_URL ?? "https://crm.karamad.net"
  }/media`;
  static redirect_url: string =
    env.REACT_APP_SSO_URL ?? "https://sso.karamad.net/";
  static sso_api_url: string =
    env.REACT_APP_SSO_API_URL ?? "https://sso.karamad.net/api/v1/";

  /** Empty string = cookies scoped to current host (required for localhost). */
  static domain: string = env.REACT_APP_COOKIE_DOMAIN ?? ".karamad.net";

  /**
   * Local dev only. Never set REACT_APP_MOCK_AUTH=true in production builds.
   * Skips SSO redirects so you can work on UI at localhost:3000.
   */
  static mockAuth: boolean = env.REACT_APP_MOCK_AUTH === "true";

  static getCookieOptions(): { path: string; domain?: string } {
    if (this.domain) {
      return { path: "/", domain: this.domain };
    }
    return { path: "/" };
  }

  static shouldRedirectToSso(): boolean {
    return !this.mockAuth;
  }

  static redirectToSso(path = "authentication/init"): void {
    if (!this.shouldRedirectToSso()) {
      return;
    }
    window.location.href = `${this.redirect_url}${path}`;
  }
}
